<script>
    import VcPaginacao from "@/components/Form/Paginacao";

    export default {
        components: {
            VcPaginacao,
        },
        data() {
            return {
                pagination: {},
                creditosDebitos: [],
                termo: "",
                filtro: null,
                order: "ASC",
                campo: "created_at",
                porPagina: {label: "100", value: "100"},
                operacao: {label: "Todas", value: "TODOS"}
            };
        },

        watch: {
            termo() {
                this.navigate(1);
            },
            porPagina() {
                this.navigate(1);
            },
            filtro() {
                this.navigate(1);
            },
            operacao() {
                this.navigate(1);
            }
        },

        methods: {
            navigate(pagina) {
                this.$http.post("api/creditoDebito/listagem?page=" + pagina, {
                    termo: this.termo,
                    campo: this.campo,
                    ordem: this.order,
                    porPg: this.porPagina.value,
                    operacao: this.operacao.value
                }).then(response => {
                    this.creditosDebitos = response.data.data;
                    this.pagination = response.data;
                });
            },

            ordenar(campo) {
                this.$set(this, "campo", campo);
                if (this.order === "ASC") {
                    this.order = "DESC";
                } else {
                    this.order = "ASC";
                }
                this.navigate(1);
            },

            deletar(credito) {
                this.$http.delete("api/creditoDebito/" + credito.id).then(() => {
                    this.navigate(1);
                    return window.swal("Sucesso", "Crédito / Débito removido com sucesso.", "success");
                }).catch(error => {
                    return window.swal("Atenção", "Houve um problema. <br><br>" + error.response.data.message, "warning");
                });
            },

            alterar(credito) {
                this.$router.push({name: "creditoDebito.editar", params: {id: credito.id}});
            },
        },

        mounted() {
            this.navigate(1);
            this.$store.dispatch("setTitle", "Créditos / Débitos");
        }
    };

</script>

<template>
    <div class="margin-top-10">
        <div class="col-xs-12 col-sm-12">
            <div class="form-group">
                <router-link :to="{name: 'creditoDebito.adicionar'}" class="btn btn-success">Adicionar</router-link>
            </div>
        </div>
        <br>
        <br>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <label>Registros por página</label>
                        <v-select
                                v-model="porPagina"
                                :options="[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '50', value: '50'},
                                {label: '100', value: '100'},
                            ]"
                        ></v-select>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Operação</label>
                            <v-select
                                    v-model="operacao"
                                    :options="[
                                    {label: 'Todas', value: 'TODOS'},
                                    {label: 'Crédito', value: 'CREDITO'},
                                    {label: 'Débito', value: 'DEBITO'},
                                ]"
                            ></v-select>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 pull-right">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="text" v-model="termo" class="form-control" placeholder="Pesquisar">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <table class="table dataTable table-striped">
                            <thead>
                            <tr role="row">
                                <th width="10%" @click="ordenar('created_at')">Data</th>
                                <th width="30%" @click="ordenar('razao_social')">Remetente</th>
                                <th width="30%" @click="ordenar('descricao')">Descrição</th>
                                <th width="10%" @click="ordenar('operacao')">Operação</th>
                                <th width="10%" @click="ordenar('valor')">Valor (R$)</th>
                                <th width="10%" class="text-center"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr role="row" class="even" :key="index" v-for="(credito, index) in creditosDebitos">
                                <td>{{ credito.created_at }}</td>
                                <td>{{ credito.remetente.nomerazao_social }} <br> {{ credito.remetente.cpfcnpj }}</td>
                                <td>{{ credito.descricao }}</td>
                                <td>{{ credito.operacao == 'CREDITO' ? 'Crédito' : 'Débito' }}</td>
                                <td>{{ credito.valor | formatMoney }}</td>
                                <td v-if="credito.pedido_id == null">
                                    <button class="btn btn-xs btn-success" @click="alterar(credito)" title="Alterar">
                                        <i class="fa fa-pen"></i>
                                    </button>&nbsp;
                                    <button class="btn btn-xs btn-danger" @click="deletar(credito)"
                                            title="Deletar crédito / débito">
                                        <i class="fa fa-times"></i>
                                    </button>&nbsp;
                                </td>
                                <td v-else>
                                    Aplicado em {{ credito.data_aplicacao }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th,
    table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111;
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

    .lista-analises button {
        margin-left: 5px;
    }

    .nav-tabs > li.active > a {
        font-weight: bold;
    }

    .table-striped > tbody > tr:nth-of-type(odd) {
        background-color: #ebeef2;
    }
</style>
